import TaxItem from '../Domain/TaxItem.js';
import AuthService from './authService.js';

class TaxService 
{
    static GetTaxListByOfficeId(officeId)
    {
        return AuthService.getInstance().CallBackendFunction("/api/Tax/GetTaxesByOfficeId/" + officeId);
    }

    static GetTaxesByEntityTypeIdAndEntityId(entityTypeId, entityId)
    {
        let url="/api/Tax/GetTaxesByEntityTypeIdAndEntityId/?" 
        + "entityTypeId="+entityTypeId
        + "&entityId="+entityId;
        return AuthService.getInstance().CallBackendFunction(url);
    }

    static GetTaxesByOfficeIdWithExclusion(officeId,entityTypeId, entityId)
    {
        let url="/api/Tax/GetTaxesByOfficeIdWithExclusion/?" 
        + "officeId="+officeId
        + "&entityTypeId="+entityTypeId
        + "&entityId="+entityId;
        let authService=AuthService.getInstance();
        return authService.CallBackendFunction(url);
    }

    static AssociateTax(entityTypeId, entityId, selectedIds)
    {
        let AssociateTaxJSON=JSON.stringify({
            EntityTypeId: entityTypeId,
            EntityId: entityId,
            SelectedIds: selectedIds,
        });
        return AuthService.getInstance()
            .CallBackendFunctionPost("/api/Tax/AssociateTaxes/",AssociateTaxJSON);
    }



    static ConvertDBItem(items)
    {
        var convertedItems = [];

        if (items !== null)
        {
            items.forEach(item =>
            {
                var newItem = new TaxItem(item);
                convertedItems.push(newItem);
            });
        }

        return convertedItems;
    }

    static async DeleteTax(taxId)
    {
        let url = "api/Tax/DeleteTax/" + taxId;
        var authService = AuthService.getInstance();
        return authService.CallBackendFunctionPost(url,{});
    }

    static async ActivateDeactivateTax(tax)
    {
        let url = "api/Tax/ActivateDeactivateTax/" + tax.TaxId;
        tax.Inactive=!tax.Inactive;
        let authService = AuthService.getInstance();
        return authService.CallBackendFunctionPut(url,tax);
    }
    static async PutTax(taxItem)
    {
        var taxData = TaxService.CreateTaxItemJSONObject(taxItem);
        let taxId=taxItem.TaxId===""?"0":taxItem.TaxId;

        let url = "api/Tax/PutTax/" + taxId;
        var authService = AuthService.getInstance();
        return authService.CallBackendFunctionPut(url, taxData);
    }

    static CreateTaxItemJSONObject(taxItem)
    {
        let taxObj = { ...taxItem };
        for (const key in taxObj)
        {
            if (taxObj[key]!==undefined && taxObj[key]!==null )
            {
                taxObj[key] = taxObj[key].toString();
            }
        }
        return JSON.stringify(taxObj);
    }

}

export default TaxService;